// componentRegistry.js

// Static Imports
export { default as VueDjGantt } from "@/components/common/VueDjGantt.vue";
export { default as DateRangePicker } from "@/components/common/DateRangePicker.vue";
export { default as ScheduleSupportMenu } from "@/components/schedule/ScheduleSupportMenu.vue";
export { default as RowSupportMenu } from "@/components/schedule/RowSupportMenu.vue";

export const TeacherAssignment = () => import("@/components/schedule/TeacherAssignment.vue");
export const TeacherScheduleItem = () => import("@/components/teacher/TeacherScheduleItem.vue");
export const ViewStudentsSchedules = () => import("@/components/schedule/ViewStudentsSchedules.vue");
export const ViewTeachersSchedules = () => import("@/components/schedule/ViewTeachersSchedules.vue");
export const NewStudentSchedule = () => import("@/components/schedule/NewStudentSchedule.vue");
export const EditStudentSchedule = () => import("@/components/schedule/EditStudentSchedule.vue");
export const NewTeacherSchedule = () => import("@/components/schedule/NewTeacherSchedule.vue");
export const EditTeacherSchedule = () => import("@/components/schedule/EditTeacherSchedule.vue");
export const NewTeacherAvailability = () => import("@/components/schedule/NewTeacherAvailability.vue");
export const ScheduleChartLegend = () => import("@/components/schedule/ScheduleChartLegend.vue");
export const StudentAttendance = () => import("@/components/attendance/StudentAttendance.vue");
export const SingleStudentAttendanceView = () => import("@/components/attendance/SingleStudentAttendanceView.vue");
export const EmailTeacherSchedules = () => import("@/components/schedule/EmailTeacherSchedules.vue");
export const StudentScheduleLookup = () => import("@/components/student/StudentScheduleLookup.vue");
export const TeacherScheduleLookup = () => import("@/components/teacher/TeacherScheduleLookup.vue");
export const GlobalLookup = () => import("@/components/schedule/GlobalLookup.vue");
export const OverlappingSchedules = () => import("@/components/schedule/OverlappingSchedules.vue");
export const HolidayClosureSchedule = () => import("@/components/schedule/HolidayClosureSchedule.vue");
export const HolidayClosureForm = () => import("@/components/schedule/HolidayClosureForm.vue");
export const SchedulingActivities = () => import("@/components/schedule/SchedulingActivities.vue");
